import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ITEMSTATUS, TYPESOFORDERS } from "../../contants";
import {
  setActiveOrder,
  activateOrder,
  pushItemToActiveOrder,
  changeItemQuantity,
  removeItem,
  setDiscount,
  setOtherCharges,
  updateOrderDiscountSocket,
  deleteLocalOrder,
  confirmOrder,
  updateOrder,
  setKOTitemsData,
  calculateKOT,
  setKOTinSocket,
  setOrderConfermation,
} from "../../redux/action/orderActions";
import {
  activateOrderOffline,
  pushItemToActiveOrderOffline,
  changeItemQuantityOffline,
  removeItemOffline,
  getOfflineLastOrderNumber,
  deleteLocalOrderOffline,
} from "../../redux/action/offlineDataActions";
import calculateOrderTotals from "../../helpers/calculateOrderTotals";
import roundOffTotal from "../../helpers/roundOffTotal";
import { findActiveOrderIndex } from "../../redux/reducers/newOrderReducer";
import getoffiledata from "../../helpers/readOfflineData";
import { RootUrl } from "../../redux/types";
import "./NewOrderDashboard.css";

// Import Components
import CategorySelector from "./components/CategorySelector";
import ItemCard from "./components/ItemCard";
import OrderItemsList from "./components/OrderItemsList";
import ActionButtons from "./components/ActionButtons";
import CustomerDetailsAccordion from "./components/CustomerDetailsAccordion";
import OrderSummary from "./components/OrderSummary";
import CustomSelect from "./components/CustomSelect";
import TodaysReservationModal from "../../components/common/Modals/TodaysReservationModal";
import Badge from "../../components/common/Badge/Badge";
import VariantSelectorModal from "../../components/common/Modals/VariantSelectorModal";
import PaymentSettleModal from "../../components/common/Modals/PaymentSettleModal";
import OrderConfirmModal from "../../components/common/Modals/OrderConfirmModal";
import { pushToppingToItem } from "../../redux/action/orderActions";
import {
  setKOTPrintData,
  setPrintData,
  setPrintDataForAdmin,
} from "../../redux/action/utilActions";
import { uuid } from "uuidv4";
import { CURRENCY } from "../../contants";
import {
  getComparator,
  stableSort,
} from "../../components/common/SmartTable/functions";
import OrderSummaryHeaderWithSelector from "./components/OrderSummaryHeaderWithSelector";
import haptics from "../../helpers/haptics";
import {
  getTableTypeFromOrder,
  parseFloat2Decimals,
  getMealNameByIST,
  getPaymentType,
  getGroupedOrderItems,
  mapOrderItemsWithTablePrice,
} from "./helpers/orderHelpers";
import useTodaysBookings from "../../hooks/useTodaysBookings";

const NewDesktopDashboard = ({ handleKot, handleCustomerForm }) => {
  const dispatch = useDispatch();

  // Selectors (same as your original)
  const {
    activeOrders,
    activeOrder: refId,
    allItems,
    itemCategories,
  } = useSelector((state) => state.order);
  const { tables } = useSelector((state) => state.branch);
  const { allTables, lastOrderNumber } = useSelector((state) => state.order);
  const {
    cgst,
    sgst,
    name: username,
    id: userId,
    restaurantId,
    role,
    branchId,
    branchCode,
  } = useSelector((state) => state.user);

  const {
    lowerRoundOff,
    upperRoundOff,
    exclusiveGST,
    enableKOT,
    enablePrinting,
    enableKDS,
  } = useSelector((state) => state.util);
  const { itemAvailability } = useSelector((state) => state.common);
  const { isOnline, isAppOffline } = useSelector(
    (state) => state.networkStatus,
  );
  const isElectron = window?.api?.isElectron;

  // State (same as your original)
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [tableFilterId, setTableFilterId] = useState("all");
  const [discountPercent, setDiscountPercent] = useState("");
  const [discountAmount, setDiscountAmount] = useState(0);
  const [otherCharges, setOtherCharges] = useState(0);
  const [selectedOrderType, setSelectedOrderType] = useState(
    TYPESOFORDERS[0].value,
  );
  const [isDetailsAccordionOpen, setIsDetailsAccordionOpen] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");
  const [remarks, setRemarks] = useState("");
  const [currentTime, setCurrentTime] = useState(new Date());
  const [bookingModalOpen, setBookingModalOpen] = useState(false);
  const [variantsItem, setVariantsItem] = useState(null);
  const [orderSummaryFilter, setOrderSummaryFilter] = useState("active");
  const [settleOpen, setSettleOpen] = useState();
  const [prePrintOpen, setPrePrintOpen] = useState();
  const [print, setPrintState] = useState();
  const bookings = useTodaysBookings();

  // Get current order (same as your original)
  const orderIndex = findActiveOrderIndex(activeOrders, refId);
  const currentOrder =
    activeOrders && orderIndex !== null ? activeOrders[orderIndex] : null;

  const tableKind = getTableTypeFromOrder(tables, currentOrder);
  const tableType = [{ tableType: tableKind }];

  const roundOffType = lowerRoundOff
    ? "lowerRoundOff"
    : upperRoundOff
      ? "upperRoundOff"
      : "standardRoundOff";

  useEffect(() => {
    if (currentOrder) {
      setCustomerName(currentOrder?.customerName || "");
      setCustomerPhone(currentOrder?.customerMobile || "");
      setDiscountAmount(currentOrder?.discount || 0);
      setOtherCharges(currentOrder?.otherCharges || 0);
      setDiscountPercent("");
      setRemarks(currentOrder?.remarks || "");
    }
  }, [currentOrder?.refId]);

  useEffect(() => {
    if (currentOrder) {
      setCustomerName(currentOrder?.customerName || "");
    }
  }, [currentOrder?.customerName]);

  useEffect(() => {
    if (currentOrder) {
      setCustomerPhone(currentOrder?.customerMobile || "");
    }
  }, [currentOrder?.customerMobile]);

  useEffect(() => {
    if (currentOrder) {
      setDiscountAmount(currentOrder?.discount || 0);
    }
  }, [currentOrder?.discount]);

  useEffect(() => {
    if (currentOrder) {
      setOtherCharges(currentOrder?.otherCharges || 0);
    }
  }, [currentOrder?.otherCharges]);

  useEffect(() => {
    if (currentOrder) {
      setRemarks(currentOrder?.remarks || "");
    }
  }, [currentOrder?.remarks]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  // Helper functions (same as your original)
  const checkactive = (tableNumber) => {
    return (
      (activeOrders || []).find((table) => table.tableNumber === tableNumber) ||
      false
    );
  };

  const handleTableClick = async (table) => {
    if (checkactive(table.tableNumber)) {
      dispatch(setActiveOrder(checkactive(table.tableNumber).refId));
    } else {
      if ((isAppOffline || !isOnline) && isElectron) {
        dispatch(getOfflineLastOrderNumber(await getoffiledata("orderCount")));
        dispatch(activateOrderOffline({ ...table }, username));
      } else {
        dispatch(activateOrder({ ...table }, username));
      }
    }
  };

  const handleDeleteTable = (e, table) => {
    e.stopPropagation();
    e.preventDefault();

    const activeTable = checkactive(table.tableNumber);

    if (!activeTable) {
      return; // Table is not active, nothing to delete
    }

    // Check if table has items - silently return
    if (activeTable.orderItems && activeTable.orderItems.length > 0) {
      return;
    }

    // Delete the order without confirmation
    if ((isAppOffline || !isOnline) && isElectron) {
      dispatch(deleteLocalOrderOffline(activeTable.refId));
    } else {
      dispatch(deleteLocalOrder(activeTable.refId));
    }
  };

  const handleDeleteOrder = (e, order) => {
    e.stopPropagation();
    e.preventDefault();

    // Check if order has items - silently return
    if (order.orderItems && order.orderItems.length > 0) {
      return;
    }

    // Delete the order without confirmation
    if ((isAppOffline || !isOnline) && isElectron) {
      dispatch(deleteLocalOrderOffline(order.refId));
    } else {
      dispatch(deleteLocalOrder(order.refId));
    }
  };

  const handleOrderTypeClick = async (type) => {
    if ((isAppOffline || !isOnline) && isElectron) {
      dispatch(getOfflineLastOrderNumber(await getoffiledata("orderCount")));
      dispatch(
        activateOrderOffline(
          { orderType: type.key, orderTypeId: type.value },
          username,
        ),
      );
    } else {
      dispatch(
        activateOrder(
          { orderType: type.key, orderTypeId: type.value },
          username,
        ),
      );
    }
  };

  const handleItemClick = (item, isVariant) => {
    // dispatch(pushItemToActiveOrder({ item, isVariant, tableType}));
    if ((isAppOffline || !isOnline) && isElectron) {
      dispatch(pushItemToActiveOrderOffline({ item, isVariant, tableType }));
    } else {
      dispatch(pushItemToActiveOrder({ item, isVariant, tableType }));
    }
  };

  const handleVariantClick = (variant, item) => {
    // Pass the variant directly as the item (variant already has the correct price)
    handleItemClick(variant, true);
  };

  const handleToppingSubmit = (toppings) => {
    dispatch(pushToppingToItem({ toppings, isVariant: true }));
  };

  // Helper function to make topping object (from old code)
  const makeToppingObject = (data) => {
    let toppings = {};

    data?.toppingField?.map(
      (extra) =>
        (toppings = {
          ...toppings,
          [extra?.toppingFieldName?.toLowerCase()]: data?.extras?.filter(
            (item) => item?.categories === extra?.toppingFieldName,
          ),
        }),
    );

    return toppings;
  };

  const handleQuantityChange = (item, kotIndex, change) => {
    const tableKind = tableType[0]?.tableType;

    // Prevent quantity from going below 1
    const newQuantity = item.quantity + change;
    if (newQuantity < 1 && !item?.isFeatured) {
      return;
    }

    if ((isAppOffline || !isOnline) && isElectron) {
      dispatch(
        changeItemQuantityOffline({
          quantity: change,
          itemId: item.itemId,
          tableType: tableKind,
        }),
      );
    } else {
      dispatch(
        changeItemQuantity({
          quantity: change,
          itemId: item.itemId,
          tableType: tableKind,
          index: kotIndex,
          item: item,
        }),
      );
    }
  };

  const handleDeleteItem = (item, kotNumber, kotIndex) => {
    if ((isAppOffline || !isOnline) && isElectron) {
      dispatch(removeItemOffline(item.itemId));
    } else {
      dispatch(removeItem(item.id, kotIndex));
    }
  };

  const applyDiscount = () => {
    if (discountPercent) {
      const discount =
        (getOrderData().grandTotalWithoutDiscount *
          parseFloat(discountPercent)) /
        100;
      dispatch(setDiscount(discount));
      dispatch(updateOrderDiscountSocket(currentOrder.refId, { discount }));
    } else if (discountAmount) {
      dispatch(setDiscount(parseFloat(discountAmount)));
      dispatch(
        updateOrderDiscountSocket(currentOrder.refId, {
          discount: parseFloat(discountAmount),
        }),
      );
    }
  };

  const applyOtherCharges = () => {
    if (otherCharges) {
      dispatch(setOtherCharges(parseFloat(otherCharges)));
    }
  };

  // Get table types
  const getTableTypes = () => {
    const key = "tableType";
    const uniqueTypes = [
      ...new Map(allTables.map((item) => [item[key], item])).values(),
    ];

    return [
      { value: "all", label: "All Tables", tableTypeId: "all" },
      ...uniqueTypes.map((type) => ({
        value: type.tableTypeId,
        label: type.tableType,
        tableTypeId: type.tableTypeId,
      })),
    ];
  };

  // Get filtered items
  const tableTypeBgColors = {
    AC: { bgColor: "#0097A7", color: "#E0F7FA" }, // Light cyan + teal text
    "Non AC": { bgColor: "#FBC02D", color: "#3E2723" }, // Light yellow + brown text
    Garden: { bgColor: "#43A047", color: "#E8F5E9" }, // Light green + dark green text
    "Banquet Hall": { bgColor: "#8E24AA", color: "#F3E5F5" }, // Light lavender + purple text
    Hut: { bgColor: "#E53935", color: "#FFEBEE" }, // Light pink + dark red text
    "Room Services": { bgColor: "#607D8B", color: "#ECEFF1" }, // Light gray + slate text
    Active: { bgColor: "#1976D2", color: "#1976D2" }, // Occupied/Active blue
  };

  const checkActiveTable = (tableNumber) => {
    if (
      activeOrders.findIndex((table) => {
        return tableNumber === table.tableNumber;
      }) >= 0
    ) {
      return true;
    } else {
      return false;
    }
  };

  const getParcelOrders = () => {
    return activeOrders
      .filter((order) => order.orderTypeId === TYPESOFORDERS[1].value)
      .map((order) => {
        // Attach bgStyles using parcel color from TYPESOFORDERS
        const bgStyles = { backgroundColor: TYPESOFORDERS[1].bgColor };
        return { ...order, bgStyles };
      });
  };

  const getHomeDeliveryOrders = () => {
    return activeOrders
      .filter((order) => order.orderTypeId === TYPESOFORDERS[2].value)
      .map((order) => {
        // Attach bgStyles using home delivery color from TYPESOFORDERS
        const bgStyles = { backgroundColor: TYPESOFORDERS[2].bgColor };
        return { ...order, bgStyles };
      });
  };

  const handleOtherOrderClick = (order) => {
    dispatch(setActiveOrder(order.refId));
  };

  // Get filtered tables
  // Enhance getFilteredTables to also assign tableTypeBgColors to each table returned
  const getFilteredTables = () => {
    let filteredTables;
    if (tableFilterId === "all") {
      filteredTables = allTables;
    } else {
      filteredTables = allTables.filter(
        (tab) => tab.tableTypeId === tableFilterId,
      );
    }

    // Attach tableTypeBgColors as 'bgStyles' property to each table based on tableType
    return filteredTables.map((table) => {
      const bgStyles = tableTypeBgColors[table.tableType] || {};
      return { ...table, bgStyles };
    });
  };

  const getFilteredItems = () => {
    let items = [...allItems]; // Copy the array before sorting

    if (searchQuery) {
      items = items.filter((item) =>
        item.itemName?.toLowerCase().includes(searchQuery.toLowerCase()),
      );
    }

    if (selectedCategory !== "all") {
      items = items.filter((item) => item.categoryName === selectedCategory);
    }

    // Sort items by sequence (ascending). If sequence is undefined, null, or empty, default to Infinity so they go to the end.
    items.sort((a, b) => {
      const seqA =
        a.sequence === undefined || a.sequence === null || a.sequence === ""
          ? Infinity
          : Number(a.sequence);
      const seqB =
        b.sequence === undefined || b.sequence === null || b.sequence === ""
          ? Infinity
          : Number(b.sequence);
      if (seqA !== seqB) {
        return seqA - seqB;
      }
      return (a.itemName || "").localeCompare(b.itemName || "");
    });

    return items;
  };

  // Get order data for calculations
  const getOrderData = () => {
    if (!currentOrder) {
      return {
        subTotal: 0,
        cgstCharges: 0,
        sgstCharges: 0,
        discount: 0,
        otherCharges: 0,
        grandTotal: 0,
        grandTotalWithoutDiscount: 0,
      };
    }

    const discount = currentOrder.discount || 0;
    const otherCharges = currentOrder.otherCharges || 0;

    return calculateOrderTotals(
      currentOrder,
      cgst,
      sgst,
      otherCharges,
      discount,
      tableType[0]?.tableType,
      exclusiveGST,
    );
  };

  const orderData = getOrderData();

  useEffect(() => {
    if (
      currentOrder &&
      currentOrder.discountPercentage > 0 &&
      orderData.discount !== currentOrder.discount
    ) {
      dispatch(
        setDiscount({
          discount: orderData.discount,
          discountPercentage: currentOrder.discountPercentage,
        }),
      );
      dispatch(
        updateOrderDiscountSocket(currentOrder.refId, {
          discount: orderData.discount,
          discountPercentage: currentOrder.discountPercentage,
        }),
      );
    }
  }, [
    currentOrder?.discountPercentage,
    orderData.discount,
    currentOrder?.discount,
    currentOrder?.refId,
    dispatch,
  ]);

  const finalGrandTotal =
    roundOffTotal(orderData.grandTotal || 0, roundOffType) || 0;
  const roundOffValue = finalGrandTotal - (orderData.grandTotal || 0);

  // Get all order items grouped by KOT
  const orderItemsGrouped = getGroupedOrderItems(currentOrder);

  const getImageUrl = (item) => {
    if (!isOnline && !isAppOffline && isElectron) {
      return `file://C:/MealBill${item.itemImage}`;
    }
    return `${RootUrl}/${item?.itemImage}`;
  };

  const handleAddToppings = (toppings) => {
    dispatch(pushToppingToItem({ toppings, isVariant: true }));
  };

  const findTitle = (orderType) => {
    return orderType.charAt(0);
  };

  // Calculate KOT
  const calKOT = () => {
    return calculateKOT({
      active: currentOrder,
      lastOrderNumber,
      activeOrders,
    });
  };

  // Handle close settle modal
  const handleCloseSettleModal = () => {
    setOtherCharges("");
    setDiscountAmount("");
    setSettleOpen();
  };

  // Handle Print KOT Button
  const handlePrintKOT = async () => {
    if (!currentOrder) {
      return;
    }
    await handleKot(
      tableType,
      {
        customerName: currentOrder.customerName,
        customerMobile: currentOrder.customerMobile,
        remarks: currentOrder.remarks,
      },
      true,
    );
  };

  const printKOT = (customerData) => {
    const { kotItems, kotData } = calKOT();

    if (kotItems?.length > 0 && enableKOT) {
      kotItems.forEach((dataitem) => {
        const foundmyItem = currentOrder.orderItems.findIndex(
          (item) => item.itemId === dataitem.itemId,
        );
        currentOrder.orderItems[foundmyItem].itemStatus = ITEMSTATUS[1].key;
        currentOrder.orderItems[foundmyItem].itemStatusId = ITEMSTATUS[1].value;
        currentOrder.orderItems[foundmyItem].kotQuantity =
          currentOrder.orderItems[foundmyItem].quantity;
      });
      currentOrder.KOTS.push({
        id: uuid(),
        status: ITEMSTATUS[1].key,
        statusId: ITEMSTATUS[1].value,
        orderItems: kotItems,
      });

      // if (!isAppOffline && isOnline) {
      //   setKOTinSocket(currentOrder.refId, currentOrder);
      // }

      // dispatch(setKOTPrintData({
      //   ...currentOrder,
      //   ...customerData,
      // }));
    }
  };

  // Handle Pre Print (Bill without printing)
  const handlePrePrintOpen = (printFlag) => {
    setPrintState(printFlag);
    if (!currentOrder) {
      return alert("No active order");
    }
    if (currentOrder.orderItems.length === 0) {
      return alert("No item selected");
    }

    if (currentOrder.orderItems.length > 0) {
      printKOT({
        customerData: {
          customerName: currentOrder.customerName,
          customerMobile: currentOrder.customerMobile,
          remarks: currentOrder.remarks,
        },
      });
    }
    setPrePrintOpen(true);
    if (currentOrder.customerName || currentOrder.customerMobile) {
      handleConfirmOrder(undefined, undefined, undefined, printFlag);
    }
  };

  // Handle Bill Print Button
  const handleBillPrint = () => {
    handlePrePrintOpen(true);
  };

  const getOrderTotals = () => {
    if (!currentOrder) return null;
    // Use the same inputs as getOrderData() so both produce identical GST values
    const discount = currentOrder.discount || 0;
    const currentOtherCharges = currentOrder.otherCharges || 0;
    const tableTypeStr = getTableTypeFromOrder(tables, currentOrder);
    return calculateOrderTotals(
      currentOrder,
      cgst,
      sgst,
      currentOtherCharges,
      discount,
      tableTypeStr,
      exclusiveGST,
    );
  };

  const getMappedOrderItems = () => {
    if (!currentOrder?.orderItems) return [];
    const tableTypeStr = getTableTypeFromOrder(tables, currentOrder);
    return mapOrderItemsWithTablePrice(currentOrder.orderItems, tableTypeStr);
  };

  // Handle Confirm Order
  const handleConfirmOrder = (paymentData, others, cb, printFlagOverride) => {
    const isPrint = printFlagOverride !== undefined ? printFlagOverride : print;
    const customerData = handleCustomerForm();
    const totals = getOrderTotals();
    const roundedGrandTotal = roundOffTotal(
      totals?.grandTotal || 0,
      roundOffType,
    );

    let orderdata = {
      ...currentOrder,
      ...totals,
      otherCharges: parseFloat2Decimals(totals?.otherCharges ?? 0),
      discount: parseFloat2Decimals(totals?.discount ?? 0),
      itemsTotal: totals?.gstItemsTotal,
      grandTotal: roundedGrandTotal,
      isExclusiveGST: exclusiveGST,
      orderItems: getMappedOrderItems(),
      orderBy: username,

      paymentType: undefined,
      paymentTypeId: undefined,
      tableNumber: currentOrder.tableNumber,
      tableId: currentOrder._id,
      restaurantId,
      branchId,
      orderNumber: lastOrderNumber + (activeOrders.length - orderIndex),
      branchCode: branchCode,
      orderType: currentOrder.orderType,
      orderTypeId: currentOrder.orderTypeId,
      isPaid: false,
      isBillPrinted: true,

      ...customerData,
      ...paymentData,

      ...others,
    };
    setPrePrintOpen(false);
    if (!isAppOffline && isOnline) {
      dispatch(
        confirmOrder(orderdata, (data) => {
          cb && cb();
          if (isPrint) {
            // Always override server response with fresh calculated totals
            // so the bill matches the Order Summary exactly.
            const printPayload = {
              ...data,
              cgstCharges: totals?.cgstCharges ?? data.cgstCharges,
              sgstCharges: totals?.sgstCharges ?? data.sgstCharges,
              taxTotal: totals?.taxTotal ?? data.taxTotal,
              itemsTotal: totals?.gstItemsTotal ?? data.itemsTotal,
              grandTotal: roundedGrandTotal,
              isExclusiveGST: exclusiveGST,
              printId: uuid(),
            };
            if (role === "branchadmin") {
              dispatch(setPrintData(printPayload));
            } else {
              dispatch(setPrintDataForAdmin(printPayload));
            }
          }
        }),
      );
      dispatch(setOrderConfermation(currentOrder));
    }
  };

  // Handle Settle Click
  const handleSettleClick = () => {
    haptics.success();
    if (!currentOrder) {
      return alert("No active order");
    }
    if (currentOrder.orderItems.length === 0) {
      return alert("No item selected");
    }

    const customerData = handleCustomerForm();
    const totals = getOrderTotals();
    const roundedGrandTotal = roundOffTotal(
      totals?.grandTotal || 0,
      roundOffType,
    );
    let orderdata = {
      ...currentOrder,
      ...totals,
      otherCharges: parseFloat2Decimals(totals?.otherCharges ?? 0),
      discount: parseFloat2Decimals(totals?.discount ?? 0),
      itemsTotal: totals?.gstItemsTotal,
      grandTotal: roundedGrandTotal,
      isExclusiveGST: exclusiveGST,
      orderItems: getMappedOrderItems(),
      orderBy: username,

      paymentType: undefined,
      paymentTypeId: undefined,
      tableNumber: currentOrder.tableNumber,
      tableId: currentOrder._id,
      restaurantId,
      branchId,
      orderNumber: lastOrderNumber + (activeOrders.length - orderIndex),
      branchCode: branchCode,
      isPaid: false,
      isBillPrinted: true,

      ...customerData,

      ...(currentOrder?.isEdited && {
        isEdited: true,
        isOrderConfirmed: true,
        isPaid: true,
        _id: currentOrder.id || currentOrder._id,
      }),
    };

    handleOpenSettleModal(orderdata);
  };

  // Handle Open Settle Modal
  const handleOpenSettleModal = (data) => {
    setSettleOpen(data);
  };

  // Handle Settle Payment
  const onSettlePayment = (paymentData, customerData) => {
    if (isAppOffline || !isOnline) {
      window.api.createOrderOffline({
        ...settleOpen,
        ...paymentData,
        ...customerData,
        paymentType: getPaymentType(paymentData.paymentMethods),
        orderStatus: "completed",
        isEdited: false,
        isOrderConfirmed: true,
        isPaid: true,
        branchOrderNumber: currentOrder.branchOrderNumber,
      });

      dispatch(deleteLocalOrderOffline(settleOpen.refId));
      setOtherCharges("");
      setDiscountAmount("");
      setSettleOpen();
    } else {
      if (!isAppOffline && isOnline && settleOpen.isOrderConfirmed) {
        dispatch(
          updateOrder(
            {
              ...settleOpen,
              ...paymentData,
              ...customerData,
              paymentType: getPaymentType(paymentData.paymentMethods),
              orderStatus: "completed",
              isEdited: false,
              isOrderConfirmed: true,
              shift: getMealNameByIST(itemAvailability),
              isPaid: true,
              _id: currentOrder.id || currentOrder._id,
            },
            (data) => {
              // setOtherCharges(0);
              // setDiscountAmount(0);
              dispatch(deleteLocalOrder(settleOpen.refId, true));
              setSettleOpen();
            },
          ),
        );
      } else {
        dispatch(
          confirmOrder(
            {
              ...settleOpen,
              ...paymentData,
              ...customerData,
              paymentType: getPaymentType(paymentData.paymentMethods),
              orderStatus: "completed",
              isEdited: false,
              isOrderConfirmed: true,
              shift: getMealNameByIST(itemAvailability),
              isPaid: true,
              branchOrderNumber: currentOrder.branchOrderNumber,
            },
            () => {
              // setOtherCharges(0);
              // setDiscountAmount(0);
              dispatch(deleteLocalOrder(settleOpen.refId, true));
              setSettleOpen();
            },
            () => {},
          ),
        );
      }
    }
  };

  return (
    <>
      <div className="new-dashboard-container">
        {/* Top Header - Fixed */}
        <div className="dashboard-top-header">
          {/* Left Side - Order Type Buttons and Action Buttons */}
          <div className="header-left-section">
            {/* Order Type Tabs */}
            <div className="btn-group header-order-types" role="group">
              {TYPESOFORDERS.map((type) => (
                <button
                  key={type.value}
                  className={`btn btn-sm ${
                    selectedOrderType === type.value
                      ? "btn-primary"
                      : "btn-outline-primary"
                  }`}
                  onClick={() => handleOrderTypeClick(type)}
                >
                  {type.key}
                </button>
              ))}
            </div>

            {/* Action Buttons Below Order Types */}
            <div className="header-action-buttons">
              <div className="header-timer">
                <span>
                  {currentTime.toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </span>
              </div>
              {!isAppOffline && isOnline ? (
                <button
                  type="button"
                  className="header-btn btn wifi-on-btn btn-sm py-0 px-2 text-white"
                >
                  <i className="mdi mdi-wifi"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="header-btn  btn wifi-off-btn btn-sm py-0 px-2 text-white"
                >
                  <i className="mdi mdi-wifi-off"></i>
                </button>
              )}
              <button
                className="header-btn btn btn-primary booking-btn btn-sm py-0 px-2 position-relative"
                onClick={() => setBookingModalOpen(true)}
              >
                <i className="mdi mdi-calendar-check"></i>
                <Badge variant="primary">{bookings.length}</Badge>
              </button>
              <button
                className="header-btn fullscreen-btn btn btn-outline-dark btn-sm px-2 py-0"
                onClick={() => {
                  if (!document.fullscreenElement) {
                    document.documentElement.requestFullscreen();
                  } else {
                    document.exitFullscreen();
                  }
                }}
              >
                <i className="mdi mdi-fullscreen"></i>
              </button>

              {/* Table Type Selector - Right after fullscreen */}
              <CustomSelect
                options={getTableTypes()}
                value={tableFilterId}
                onChange={setTableFilterId}
                placeholder="All Tables"
                className="table-type-selector w-100"
              />
            </div>
          </div>

          {/* Right Side - Table Buttons (Vertical Scroll, Auto-wrap Rows) */}
          <div className="header-right-tables border-left pl-3">
            <div className="table-buttons-wrapper d-flex flex-wrap">
              {stableSort(
                getFilteredTables(),
                getComparator("asc", "tableNumber"),
              ).map((table) => {
                const activeTableOrder = checkactive(table.tableNumber) ?? null;
                const isActiveTable =
                  activeTableOrder && activeTableOrder.orderItems.length > 0;
                const canDelete =
                  activeTableOrder &&
                  (!activeTableOrder.orderItems ||
                    activeTableOrder.orderItems.length === 0);

                return (
                  <div
                    key={table.tableNumber}
                    className="position-relative table-button-wrapper"
                  >
                    <button
                      className={`table-button btn btn-sm ${
                        isActiveTable && "bg-primary text-white"
                      }`}
                      onClick={() => handleTableClick(table)}
                      style={{
                        background: table.bgStyles.bgColor,
                        color: table.bgStyles.color,
                      }}
                    >
                      {table.tableNumber}
                    </button>

                    {/* Delete Icon - Shows on active tables with no items */}
                    {canDelete && (
                      <button
                        className="table-delete-btn"
                        onClick={(e) => handleDeleteTable(e, table)}
                        title="Delete table"
                      >
                        <i className="mdi mdi-close-circle"></i>
                      </button>
                    )}
                  </div>
                );
              })}
              {getParcelOrders().map((order, index) => {
                const isActive = order.orderItems.length > 0;
                const canDelete =
                  !order.orderItems || order.orderItems.length === 0;

                return (
                  <div
                    key={index}
                    className="position-relative table-button-wrapper"
                  >
                    <button
                      className={`table-button btn btn-sm ${
                        isActive && "bg-primary text-white"
                      }`}
                      onClick={() => handleOtherOrderClick(order)}
                      style={{
                        backgroundColor: order.bgStyles.backgroundColor,
                        color: order.bgStyles.color,
                      }}
                    >
                      {findTitle(order.orderType) + (index + 1)}
                    </button>

                    {/* Delete Icon */}
                    {canDelete && isActive && (
                      <button
                        className="table-delete-btn"
                        onClick={(e) => handleDeleteOrder(e, order)}
                        title="Delete order"
                      >
                        <i className="mdi mdi-close-circle"></i>
                      </button>
                    )}
                  </div>
                );
              })}
              {getHomeDeliveryOrders().map((order, index) => {
                const isActive = order.orderItems.length > 0;
                const canDelete =
                  !order.orderItems || order.orderItems.length === 0;

                return (
                  <div
                    key={index}
                    className="position-relative table-button-wrapper"
                  >
                    <button
                      className={`table-button btn btn-sm ${
                        isActive && "bg-primary text-white"
                      }`}
                      onClick={() => handleOtherOrderClick(order)}
                      style={{
                        backgroundColor: order.bgStyles.backgroundColor,
                        color: order.bgStyles.color,
                      }}
                    >
                      {findTitle(order.orderType) + (index + 1)}
                    </button>

                    {/* Delete Icon */}
                    {canDelete && isActive && (
                      <button
                        className="table-delete-btn"
                        onClick={(e) => handleDeleteOrder(e, order)}
                        title="Delete order"
                      >
                        <i className="mdi mdi-close-circle"></i>
                      </button>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="dashboard-main-content">
          {/* Left Side - Items */}
          <div className="dashboard-left-section">
            {/* Search Bar and Category Selector */}
            <div className="search-category-section p-2 border-bottom">
              <div className="d-flex align-items-center gap-2 justify-content-between">
                {/* Search Bar - 40% */}
                <div className="position-relative" style={{ width: "40%" }}>
                  <i className="mdi mdi-magnify search-icon"></i>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Search items..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>

                {/* Category Selector - 40% */}
                <div style={{ width: "40%" }}>
                  <CategorySelector
                    categories={itemCategories}
                    selectedCategory={selectedCategory}
                    onCategoryChange={setSelectedCategory}
                    isOnline={isOnline}
                    isAppOffline={isAppOffline}
                    isElectron={isElectron}
                  />
                </div>
              </div>
            </div>

            {/* Items Grid */}
            <div className="items-grid-section p-3">
              <div className="row">
                {getFilteredItems().map((item) => (
                  <div
                    key={item._id}
                    className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-6 mb-3"
                  >
                    <ItemCard
                      item={item}
                      onClick={() =>
                        item?.variants && item.variants.length > 0
                          ? setVariantsItem(item)
                          : handleItemClick(item, false)
                      }
                      getImageUrl={getImageUrl}
                      tableType={tableType[0]?.tableType}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right Side - Order Summary */}
          <div className="dashboard-right-sidebar bg-white border-left">
            {/* Header with Active Table Info */}
            <OrderSummaryHeaderWithSelector
              currentOrder={currentOrder}
              onTabChange={setOrderSummaryFilter}
              selectedTab={orderSummaryFilter}
            />

            {/* Order Items with KOT Headers */}
            <div className="flex-grow-1 overflow-auto">
              <OrderItemsList
                tables={tables}
                currentOrder={currentOrder}
                orderItemsGrouped={orderItemsGrouped}
                handleQuantityChange={handleQuantityChange}
                handleDeleteItem={handleDeleteItem}
                onToggleDetailsAccordion={() =>
                  setIsDetailsAccordionOpen(!isDetailsAccordionOpen)
                }
                isDetailsAccordionOpen={isDetailsAccordionOpen}
              />
            </div>

            {/* Customer Details Accordion */}
            <CustomerDetailsAccordion
              key={currentOrder?.refId}
              isOpen={isDetailsAccordionOpen}
              toggleAccordion={() =>
                setIsDetailsAccordionOpen(!isDetailsAccordionOpen)
              }
              customerName={customerName}
              setCustomerName={setCustomerName}
              customerPhone={customerPhone}
              setCustomerPhone={setCustomerPhone}
              otherCharges={otherCharges}
              setOtherCharges={setOtherCharges}
              discountPercent={discountPercent}
              setDiscountPercent={setDiscountPercent}
              discountAmount={getOrderData().discount}
              setDiscountAmount={setDiscountAmount}
              currentOrder={currentOrder}
              getData={getOrderData}
              remarks={remarks}
              setRemarks={setRemarks}
            />

            {/* Totals - Simplified without Grand Total */}
            <OrderSummary
              currentOrder={currentOrder}
              orderData={orderData}
              cgst={cgst}
              sgst={sgst}
            />

            {/* Action Buttons */}
            <ActionButtons
              currentOrder={currentOrder}
              orderItemsGrouped={orderItemsGrouped}
              handleKot={(tableType, print) => {
                if (print) {
                  handlePrintKOT();
                } else {
                  handleKot(tableType, {
                    customerName: customerName,
                    customerMobile: customerPhone,
                  });
                }
              }}
              tableType={tableType}
              finalGrandTotal={finalGrandTotal}
              onBillClick={() => handlePrePrintOpen(false)}
              onPrintBillClick={() => handleBillPrint()}
              onSettleClick={() => handleSettleClick()}
            />
          </div>
        </div>
      </div>

      {/* Variant Selector Modal */}
      <VariantSelectorModal
        open={Boolean(variantsItem)}
        onClose={() => setVariantsItem()}
        title={variantsItem?.itemName}
        extras={makeToppingObject(variantsItem)}
        categories={variantsItem?.toppingField}
        variants={variantsItem?.variants || []}
        onVariantClick={(variant) => handleVariantClick(variant)}
        tableType={tableType[0]?.tableType}
        onToppingSubmit={(data) => handleToppingSubmit(data)}
      />

      <TodaysReservationModal
        open={bookingModalOpen}
        onClose={() => setBookingModalOpen(false)}
      />

      {/* Payment Settle Modal */}
      {settleOpen && (
        <PaymentSettleModal
          open={settleOpen}
          data={settleOpen}
          title={""}
          onClose={() => handleCloseSettleModal()}
          onSubmit={(data, customer) => onSettlePayment(data, customer)}
          customerName={customerName}
          customerMobile={customerPhone}
        />
      )}

      {/* Order Confirm Modal */}
      {prePrintOpen && !customerName && !customerPhone && (
        <OrderConfirmModal
          open={prePrintOpen}
          text={`Grand total : ${CURRENCY} ${(finalGrandTotal || 0).toFixed(
            2,
          )}`}
          onConfirm={() => handleConfirmOrder()}
          onCancel={() => setPrePrintOpen()}
          customerName={customerName}
          customerMobile={customerPhone}
        />
      )}
    </>
  );
};

export default NewDesktopDashboard;
